// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-bundle_purchase--modal--loading[data-v-4ccb4289]{align-items:center;display:flex;height:100%;justify-content:center}", ""]);
// Exports
module.exports = exports;
